'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeatureFlagContainer = _react2.default.createContext({});

exports.default = FeatureFlagContainer;
module.exports = exports['default'];